<script lang="ts">
	import { Icon } from '@andresot/ui';
	import { fly } from 'svelte/transition';
	import { toasts } from '$stores/toasts.svelte';
</script>

<!--
	role="status" с aria-live="polite" — программа чтения с экрана произнесёт
	текст, не перебивая пользователя. Для ошибок этого достаточно: они не
	требуют немедленного прерывания работы.
-->
<div class="toaster" role="status" aria-live="polite">
	{#each toasts.items as toast (toast.id)}
		<div class="toast {toast.kind}" transition:fly={{ y: 16, duration: 200 }}>
			{#if toast.kind !== 'info'}
				<span class="icon">
					<Icon name={toast.kind === 'success' ? 'check' : 'info'} size={18} />
				</span>
			{/if}

			<span class="text">{toast.text}</span>

			{#if toast.action}
				<button class="action" onclick={() => toasts.runAction(toast.id)}>
					{toast.action.label}
				</button>
			{/if}

			<button
				class="close"
				onclick={() => toasts.dismiss(toast.id)}
				aria-label="Закрыть уведомление"
			>
				<Icon name="close" size={16} />
			</button>
		</div>
	{/each}
</div>

<style>
	.toaster {
		position: fixed;
		left: 50%;
		bottom: var(--spacing-2xl);
		transform: translateX(-50%);
		z-index: var(--z-toast);
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--spacing-s);
		/* Контейнер не должен перехватывать щелчки по интерфейсу под ним. */
		pointer-events: none;
	}

	.toast {
		display: flex;
		align-items: center;
		gap: var(--spacing-m);
		max-width: min(480px, 90vw);
		padding: var(--spacing-m) var(--spacing-m) var(--spacing-m) var(--spacing-l);
		border-radius: var(--radius-m);
		background: var(--float-glass-flat);
		backdrop-filter: blur(20px);
		box-shadow: var(--shadow-m);
		color: var(--text-primary);
		font: var(--text-secondary-line);
		font-size: var(--font-size-m);
		/* А сами уведомления — должны. */
		pointer-events: auto;
	}

	.icon {
		display: flex;
		flex-shrink: 0;
	}

	.toast.success .icon {
		color: var(--status-success);
	}

	.toast.error .icon {
		color: var(--status-danger);
	}

	.text {
		flex: 1;
		min-width: 0;
	}

	.action {
		flex-shrink: 0;
		color: var(--accent-primary);
		font: var(--text-caption-medium);
		font-size: var(--font-size-m);
		white-space: nowrap;
	}

	.action:hover {
		text-decoration: underline;
	}

	.close {
		display: flex;
		flex-shrink: 0;
		padding: var(--spacing-2xs);
		border-radius: var(--radius-round);
		color: var(--text-tertiary);
	}

	.close:hover {
		color: var(--text-primary);
	}
</style>
